import React, { useState, useEffect } from "react";
import classes from "./SavingModal.module.css";
import api, { withCompanyId } from "../../../Components/API/Api";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";

function MemberCollectionsModal({ isOpen, onClose, onSuccess }) {
  const [rows, setRows] = useState([
    { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
  ]);

  const [reference, setReference] = useState("");
  const [supplierSearch, setSupplierSearch] = useState("");
  const [showSupplierDropdown, setShowSupplierDropdown] = useState(false);
  const navigate = useNavigate();
  const [debitSearch, setDebitSearch] = useState("");
  const [showDebitDropdown, setShowDebitDropdown] = useState(false);
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [description, setDescription] = useState("");
  const [debitAccount, setDebitAccount] = useState("");
  const [outstandingAmount, setOutstandingAmount] = useState("");
  const [selectedLoanAccount, setSelectedLoanAccount] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [loanOptions, setLoanOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [paymentTypesLoading, setPaymentTypesLoading] = useState(false);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [supplierLoading, setSupplierLoading] = useState(false);
  const [paymentToLoading, setPaymentToLoading] = useState(false);
  const paymentTypeLower = (selectedPaymentType || "").toLowerCase();
  const [creditAccounts, setCreditAccounts] = useState([]);
  const [savingsType, setSavingsType] = useState([]);
  const [savingsLoading, setSavingsLoading] = useState(false);


  const [totalAmount, setTotalAmount] = useState(""); 
  const [receiptTypes, setReceiptTypes] = useState([]);
  const [receiptTypesLoading, setReceiptTypesLoading] = useState(false);
  const [paymentSearch, setPaymentSearch] = useState("");
  const [showPaymentDropdown, setShowPaymentDropdown] = useState(false);
  const [expenseOptions, setExpenseOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
  const [receiptType, setReceiptType] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [debitAccountsLoading, setDebitAccountsLoading] = useState(false);
  const [supportingDocument, setSupportingDocument] = useState(null);
  const [supportingError, setSupportingError] = useState("");
  const [payableAccounts, setPayableAccounts] = useState([]);
  const [payableAccountsLoading, setPayableAccountsLoading] = useState(false);
  const [pendingInvoicesMap, setPendingInvoicesMap] = useState({});

  const [selectedCompanyId, setSelectedCompanyId] = useState("");
const [selectedProductCode, setSelectedProductCode] = useState("");
const [selectedProductName, setSelectedProductName] = useState("");
const [selectedProducts, setSelectedProducts] = useState([]);
const [selectedProductId, setSelectedProductId] = useState("");
// const [selectedCompanyId, setSelectedCompanyId] = useState("");
const [chequeNo, setChequeNo] = useState("");
const [savingsId, setSavingsId] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) { setSupportingDocument(null); setSupportingError(""); return; }
    if (file.type !== 'application/pdf') { setSupportingError('Only PDF files are allowed.'); setSupportingDocument(null); return; }
    const max = 2 * 1024 * 1024;
    if (file.size > max) { setSupportingError('File must be 2MB or smaller.'); setSupportingDocument(null); return; }
    setSupportingError(""); setSupportingDocument(file);
  };

  // === Reset all form fields to initial state ===
  const resetFormFields = () => {
    setRows([
      { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
    ]);
    setReference("");
    setSupplierSearch("");
    setShowSupplierDropdown(false);
    setDebitSearch("");
    setShowDebitDropdown(false);
    setTransactionDate("");
    setDescription("");
    setDebitAccount("");
    setOutstandingAmount("");
    setSelectedLoanAccount("");
    setSelectedPaymentType("");
    setPaymentSearch("");
    setShowPaymentDropdown(false);
    setTotalAmount("");
    setSelectedCurrency("");
    setSelectedPaymentMode("");
    setSupportingDocument(null);
    setSupportingError("");

    // Set NGN as default currency if available
    const ngnCurrency = currencyOptions.find(c => c.code === "NGN");
    if (ngnCurrency) setSelectedCurrency(ngnCurrency.id);
  };

  // keep handlePrinter as-is
  const handlePrinter = () => {
    const receiptData = {
      reference,
      transactionDate,
      description,
      selectedCurrency,
      selectedPaymentMode,
      debitAccount,
      totalAmount,
      rows,
    };

    navigate("/preview", {
      state: { invoice: receiptData },
    });
  };

  // --- Update outstandingAmount when reference (customer selection) changes ---
  useEffect(() => {
    if (!receiptType?.toLowerCase()?.includes("credit customer")) {
      setOutstandingAmount("");
      return;
    }

    if (!reference) {
      setOutstandingAmount("");
      return;
    }

    const customerObj = customerOptions.find(c => String(c.id) === String(reference));
    const balance = customerObj?.balance ?? 0;
    setOutstandingAmount(String(Number(balance) || 0));
  }, [reference, customerOptions, receiptType]);

  // --- Auto-fill totalAmount when supplier is selected for "payment from payables" ---
  useEffect(() => {
    const type = (selectedPaymentType || "").toLowerCase().trim();
    
    if (!type.includes("payment from payables")) {
      return;
    }

    if (!reference) {
      setTotalAmount("");
      setRows((prev) => {
        if (!prev.length) return prev;
        const newRows = [...prev];
        newRows[0] = {
          ...newRows[0],
          amount: "",
        };
        return newRows;
      });
      return;
    }

    const invoiceData = pendingInvoicesMap[reference];
    if (invoiceData) {
      const balance = String(invoiceData.balance || 0);
      setTotalAmount(balance);
      setRows((prev) => {
        if (!prev.length) {
          return [{ accountId: "", accountDisplay: "", accountCode: "", amount: balance, showDropdown: false }];
        }
        const newRows = [...prev];
        newRows[0] = {
          ...newRows[0],
          amount: balance,
        };
        return newRows;
      });
    } else {
      setTotalAmount("");
      setRows((prev) => {
        if (!prev.length) return prev;
        const newRows = [...prev];
        newRows[0] = {
          ...newRows[0],
          amount: "",
        };
        return newRows;
      });
    }
  }, [reference, pendingInvoicesMap, selectedPaymentType]);

  // --- Auto-fill Account Name and Account Code when invoice is selected for "payment from payables" ---
  useEffect(() => {
    const type = (selectedPaymentType || "").toLowerCase().trim();
    
    if (!type.includes("payment from payables")) {
      return;
    }

    if (!reference) {
      // Reset first row when no reference is selected
      setRows((prev) => {
        const newRows = [...prev];
        if (newRows[0]) {
          newRows[0] = {
            ...newRows[0],
            accountId: "",
            accountDisplay: "",
            accountCode: "",
          };
        }
        return newRows;
      });
      return;
    }

    const invoiceData = pendingInvoicesMap[reference];
    if (invoiceData && invoiceData.fullInvoice) {
      const invoice = invoiceData.fullInvoice;
      
      // Get items from invoice (try multiple field names)
      let items = invoice.items || invoice.line_items || invoice.purchase_order_items || invoice.invoice_items || [];
      
      if (Array.isArray(items) && items.length > 0) {
        const firstItem = items[0];
        
        // Get account information from the first item
        let account = null;
        
        // Try to get account from different possible locations
        if (firstItem.account && typeof firstItem.account === 'object') {
          account = firstItem.account;
        } else if (firstItem.debit_gl && typeof firstItem.debit_gl === 'object') {
          account = firstItem.debit_gl;
        }
        
        if (account) {
          const gl_name = account.gl_name || account.name || account.account_name || "";
          const gl_code = account.gl_code || account.code || "";
          const accountId = account.id || "";
          
          // Update the first row with auto-filled account information
          setRows((prev) => {
            const newRows = [...prev];
            if (newRows[0]) {
              newRows[0] = {
                ...newRows[0],
                accountId: accountId,
                accountDisplay: gl_name,
                accountCode: gl_code,
              };
            }
            return newRows;
          });
          
          console.log("✅ Auto-filled account from invoice item:", {
            gl_name,
            gl_code,
            accountId,
          });
        }
      }
    }
  }, [reference, pendingInvoicesMap, selectedPaymentType]);

  // --- Fetch customers (only when receiptType includes credit customer) ---
  useEffect(() => {
    const fetchCustomers = async () => {
      if (!receiptType?.toLowerCase()?.includes("credit customer")) return;

      try {
        setCustomerLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/customer/get');

        if (res.data && Array.isArray(res.data.data)) {
          setCustomerOptions(res.data.data);
        } else {
          setCustomerOptions([]);
        }
      } catch (err) {
        console.error("Error fetching customers:", err);
        setCustomerOptions([]);
      } finally {
        setCustomerLoading(false);
      }
    };

    fetchCustomers();
  }, [receiptType]);

  // --- Fetch loans (when receiptType includes loan repayment) ---
  useEffect(() => {
    const fetchLoanOptions = async () => {
      if (!receiptType?.toLowerCase()?.includes("loan repayment")) return;

      try {
        setPaymentToLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/loans');

        if (res.data && Array.isArray(res.data.data)) {
          setLoanOptions(res.data.data);
        } else {
          setLoanOptions([]);
        }
      } catch (err) {
        console.error("Error fetching loans:", err);
        setLoanOptions([]);
      } finally {
        setPaymentToLoading(false);
      }
    };

    fetchLoanOptions();
  }, [receiptType]);

  // --- Fetch employees (when receiptType includes employee payment) ---
  useEffect(() => {
    const fetchEmployeeOptions = async () => {
      if (!receiptType?.toLowerCase()?.includes("employee payment")) return;

      try {
        setPaymentToLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/employee/paginated');

        // Handle paginated response: { status, message, data: { current_page, data: [...], ... } }
        if (res.data && res.data.data?.data && Array.isArray(res.data.data.data)) {
          setEmployeeOptions(res.data.data.data);
        } else {
          setEmployeeOptions([]);
        }
      } catch (err) {
        console.error("Error fetching employees:", err);
        setEmployeeOptions([]);
      } finally {
        setPaymentToLoading(false);
      }
    };

    fetchEmployeeOptions();
  }, [receiptType]);

  // --- Fetch payment types ---
  useEffect(() => {
    const fetchPaymentTypes = async () => {
      setPaymentTypesLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/member', { params: { name: 'payment' } });
        if (res.data && Array.isArray(res.data.data)) {
          setPaymentTypes(res.data.data);
        } else {
          setPaymentTypes([]);
        }
      } catch (err) {
        setPaymentTypes([]);
      } finally {
        setPaymentTypesLoading(false);
      }
    };
    fetchPaymentTypes();
  }, []);

  // fetch saving types
useEffect(() => {
  const fetchSavingsTypes = async () => {
    // Don't fetch until a member is selected
    if (!selectedPaymentType) {
      setSavingsType([]);
      return;
    }

    setSavingsLoading(true);

    try {
      const res = await api.get("/v1/fetch_member_savings", {
        params: {
          member_id: selectedPaymentType, // pass selected member id
        },
      });

      if (res.data && Array.isArray(res.data.data)) {
        setSavingsType(res.data.data);
      } else {
        setSavingsType([]);
      }
    } catch (err) {
      console.error("Error fetching savings products:", err);
      setSavingsType([]);
    } finally {
      setSavingsLoading(false);
    }
  };

  fetchSavingsTypes();
}, [selectedPaymentType]);
  // --- Fetch suppliers when selectedPaymentType includes supplier or payable ---
  useEffect(() => {
    const fetchSuppliers = async () => {
      const type = (selectedPaymentType || "").toLowerCase().trim();

      // Handle "payment from payables" - fetch from pending purchase invoices endpoint
      if (type.includes("payment from payables")) {
        setSupplierLoading(true);
        try {
          const token = localStorage.getItem("authToken");
          const res = await api.get('/v1/retrieve-pending-purchase-invoices');

          const invoices = res?.data?.data;
          if (Array.isArray(invoices)) {
            const invoiceMap = {};
            const options = [];
            const processedSuppliers = new Map();

            // Process invoices to group by supplier and create display options
            invoices.forEach((invoice) => {
              const invoiceId = String(invoice.id);
              const supplierName = invoice.supplier?.name || `Supplier ${invoice.supplier_id}`;
              const invoiceNumber = invoice.invoice_number;
              const balance = invoice.balance;
              
              // Store invoice data by its ID
              invoiceMap[invoiceId] = {
                id: invoiceId,
                invoiceId,
                supplierName,
                invoiceNumber,
                balance,
                fullInvoice: invoice,
              };

              // Create display option: "Supplier Name (Invoice Number)"
              const displayLabel = `${supplierName} (${invoiceNumber})`;
              options.push({
                id: invoiceId,
                name: displayLabel,
                balance,
              });
            });

            // Log invoice structure for debugging item extraction
            console.log("📦 Pending invoices API response structure:", {
              firstInvoice: invoices[0],
              allInvoices: invoices
            });

            setPendingInvoicesMap(invoiceMap);
            setSupplierOptions(options);
          } else {
            setPendingInvoicesMap({});
            setSupplierOptions([]);
          }
        } catch (err) {
          console.error("Error fetching pending purchase invoices:", err);
          setPendingInvoicesMap({});
          setSupplierOptions([]);
        } finally {
          setSupplierLoading(false);
        }
        return;
      }

      // Original logic for regular supplier selection
      if (!type.includes("supplier") && !type.includes("payable")) {
        setSupplierOptions([]);
        setPendingInvoicesMap({});
        return;
      }

      setSupplierLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/beneficiary');

        const suppliers = res?.data?.data;
        if (Array.isArray(suppliers)) {
          const options = suppliers.map((s) => ({
            id: s.id,
            name: s.supplier_name || s.name || `Supplier ${s.id}`,
          }));
          setSupplierOptions(options);
          setPendingInvoicesMap({});
        } else {
          setSupplierOptions([]);
          setPendingInvoicesMap({});
        }
      } catch (err) {
        console.error("Error fetching suppliers:", err);
        setSupplierOptions([]);
        setPendingInvoicesMap({});
      } finally {
        setSupplierLoading(false);
      }
    };

    fetchSuppliers();
  }, [selectedPaymentType]);

  // --- Fetch Account Names and Codes ---
  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/get-expense-accounts');
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          setAccounts(res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch expense accounts", err);
      }
    };
    fetchAccounts();
  }, []);

  // --- Fetch Payable Accounts when payment type includes "payable" ---
  useEffect(() => {
    const fetchPayableAccounts = async () => {
      const type = (selectedPaymentType || "").toLowerCase().trim();

      if (!type.includes("payable")) {
        setPayableAccounts([]);
        return;
      }

      setPayableAccountsLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/get-payable-accounts');

        if (res.data && Array.isArray(res.data.data)) {
          setPayableAccounts(res.data.data);
        } else {
          setPayableAccounts([]);
        }
      } catch (err) {
        console.error("Error fetching payable accounts:", err);
        setPayableAccounts([]);
      } finally {
        setPayableAccountsLoading(false);
      }
    };

    fetchPayableAccounts();
  }, [selectedPaymentType]);

  // --- Fetch Payment Methods ---
  useEffect(() => {
    const fetchPaymentModes = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/income/get-payment-method');

        if (res.data && Array.isArray(res.data.data)) {
          setPaymentModes(res.data.data);
        } else {
          setPaymentModes([]);
        }
      } catch (err) {
        console.error("Error fetching payment methods:", err);
        setPaymentModes([]);
      }
    };
    fetchPaymentModes();
  }, []);

  // --- Fetch Currencies ---
  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/fetch-all-currencies');

        if (res.data && Array.isArray(res.data.data)) {
          setCurrencyOptions(res.data.data);

          // ✅ Set NGN as default
          const ngnCurrency = res.data.data.find(c => c.code === "NGN");
          if (ngnCurrency) setSelectedCurrency(ngnCurrency.id);
        }
      } catch (err) {
        console.error("Error fetching currencies:", err);
      }
    };
    fetchCurrencies();
  }, []);

  useEffect(() => {
    const fetchCreditAccounts = async () => {
      setDebitAccountsLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/bank-accounts');

        if (res.data && Array.isArray(res.data.data)) {
          const creditAccounts = res.data.data.map((acc) => ({
            value: acc.id,
            label: acc.gl_name || acc.name || acc.account_name,
            gl_code: acc.gl_code || acc.code,
            fullAccount: acc,
          }));
          setCreditAccounts(creditAccounts);
        } else {
          setCreditAccounts([]);
        }
      } catch (error) {
        console.error("Error fetching credit accounts:", error);
        setCreditAccounts([]);
      } finally {
        setDebitAccountsLoading(false);
      }
    };

    if (isOpen) fetchCreditAccounts();
  }, [isOpen]);

  if (!isOpen) return null;

  // === TABLE HANDLERS ===
  const addLine = () => {
    setRows((prev) => [
      ...prev,
      { accountId: "", accountDisplay: "", amount: "", showDropdown: false },
    ]);
  };

  const duplicateRow = (index) => {
    setRows((prev) => {
      const newRows = [...prev];
      const emptyRow = {
        accountId: "",
        accountDisplay: "",
        amount: "",
        showDropdown: false,
      };
      newRows.splice(index + 1, 0, emptyRow);
      return newRows;
    });
  };

  const removeRow = (index) => {
    setRows((prev) => {
      if (prev.length === 1) return prev;
      return prev.filter((_, i) => i !== index);
    });
  };

  const totalDebit = parseFloat(totalAmount || 0);
  const totalCredit = rows.reduce(
    (sum, r) => sum + (parseFloat(r.amount) || 0),
    0
  );
  const isBalanced = totalDebit === totalCredit;

  // === handleSubmit ===
const handleSubmit = async (e) => {
  e.preventDefault();

  const errors = [];

  if (!selectedPaymentType)
    errors.push("Member is required");

  if (!selectedCompanyId)
    errors.push("Company is required");

  if (!totalAmount)
    errors.push("Amount is required");

  if (!transactionDate)
    errors.push("Transaction date is required");

  if (!savingsId)
    errors.push("Savings account is required");

  // if (!selectedPaymentMode)
  //   errors.push("Mode of savings is required");

  if (!debitAccount)
    errors.push("Debit account is required");

  if (!description)
    errors.push("Description is required");

  if (!selectedCurrency)
    errors.push("Currency is required");

  if (!chequeNo)
    errors.push("Cheque number is required");

  if (errors.length > 0) {
    Swal.fire({
      icon: "error",
      title: "Missing Required Fields",
      html: errors.map(err => `<p>${err}</p>`).join(""),
      customClass: { popup: "swal-highest-zindex" },
      didOpen: () => {
        const swalPopup = document.querySelector(".swal2-container");
        if (swalPopup) swalPopup.style.zIndex = "99999";
      },
    });

    return;
  }

  setIsSaving(true);

  try {
    const debitAccountObj = JSON.parse(debitAccount);

    const payload = {
      amount: Number(totalAmount),
      company_id: Number(selectedCompanyId),
      transaction_date: transactionDate,
      cheque_number: chequeNo || null,
      description,
      account_id: Number(savingsId), // selected savings product
      bank: debitAccountObj.id,
      member_id: Number(selectedPaymentType),
      mode_of_payments: selectedPaymentMode,
    };

    console.log("Submitting Payload:", payload);

    let response;

    // if (supportingDocument) {
    if (supportingDocument) {
      const fd = new FormData();

      fd.append("amount", payload.amount);
      fd.append("company_id", payload.company_id);
      fd.append("transaction_date", payload.transaction_date);
      fd.append("cheque_number", payload.cheque_number || "");
      fd.append("description", payload.description);
      fd.append("account_id", payload.account_id);
      fd.append("bank", payload.bank);
      fd.append("member_id", payload.member_id);
      fd.append("mode_of_payments", payload.mode_of_payments || "");

      fd.append(
        "supporting_document",
        supportingDocument,
        supportingDocument.name
      );

      console.log(
        "Submitting FormData:",
        Object.fromEntries(fd.entries())
      );

      response = await api.post(
        "/v1/customer/add-savings",
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    } else {
      response = await api.post(
        "/v1/customer/add-savings",
        payload
      );
    }

    Swal.fire({
      icon: "success",
      title: "Success",
      text:
        response?.data?.message ||
        "Member savings created successfully",
      customClass: { popup: "swal-highest-zindex" },
      didOpen: () => {
        const swalPopup = document.querySelector(".swal2-container");
        if (swalPopup) swalPopup.style.zIndex = "99999";
      },
    }).then(() => {
      if (onSuccess) {
        onSuccess();
      } else {
        onClose();
      }
    });

    // Swal.fire({
    //   icon: "success",
    //   title: "Success",
    //   text:
    //     response?.data?.message ||
    //     "Member savings created successfully",
    //   customClass: { popup: "swal-highest-zindex" },
    //   didOpen: () => {
    //     const swalPopup = document.querySelector(".swal2-container");
    //     if (swalPopup) swalPopup.style.zIndex = "99999";
    //   },
    // });
    // onClose();

    console.log("Success:", response.data);

  } catch (error) {
    console.error("API Error:", error);

    const apiErrors =
      error?.response?.data?.errors;

    let errorHtml = "";

    if (apiErrors) {
      errorHtml = Object.entries(apiErrors)
        .map(([field, messages]) => {
          return `
            <p>
              <strong>${field}</strong>: 
              ${messages.join(", ")}
            </p>
          `;
        })
        .join("");
    }

    Swal.fire({
      icon: "error",
      title: "Save Failed",
      html:
        errorHtml ||
        error?.response?.data?.message,
      confirmButtonColor: "#000000ff",
      customClass: { popup: "swal-highest-zindex" },
      didOpen: () => {
        const swalContainer =
          document.querySelector(".swal2-container");

        if (swalContainer)
          swalContainer.style.zIndex = "99999";
      },
    });
  } finally {
    setIsSaving(false);
  }
};

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent}>
        <h3 className={classes.title}>Member Collections</h3>
        <div className={classes.topRow}>
          <div className={classes.Group3}>
            <label>Member Name</label>
            <select
              value={selectedPaymentType}
              onChange={(e) => {
                const memberId = e.target.value;
                setSelectedPaymentType(memberId);
                // reset savings product
                setSavingsType([]);
                setSelectedProductId("");
                setSelectedProducts([]);
                setSavingsId("");
                setSelectedCompanyId("");
              }}
            >
              <option value="">Select Member</option>

              {paymentTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
          </div>

          <div className={classes.Group3}>
            <label>Savings Account</label>
            {/* {paymentTypeLower.includes("supplier") || paymentTypeLower.includes("payable") ? ( */}
              <div className={classes.searchableDropdown}>
            <select
              value={selectedProductId}
              disabled={!selectedPaymentType}
              onChange={(e) => {
                const productId = Number(e.target.value);

                const selectedItem = savingsType.find(
                  (item) => item.id === productId
                );

                if (!selectedItem) return;

                setSelectedProductId(productId);
                setSelectedCompanyId(selectedItem.company_id);
                setSavingsId(selectedItem.id);

                setSelectedProducts([selectedItem]);
              }}
            >
              <option value="">
                {!selectedPaymentType
                  ? "Select Member First"
                  : "Select Savings Product"}
              </option>

              {savingsLoading ? (
                <option disabled>Loading savings products...</option>
              ) : (
                savingsType.map((product) => (
                  <option key={product.id} value={product.id}>
                    {product.description}
                  </option>
                ))
              )}
            </select>

          </div>
          </div>

          <div className={classes.Group}>
            <label>Date</label>
            <input
              type="date"
              value={transactionDate}
              onChange={(e) => setTransactionDate(e.target.value)}
              required
            />
          </div>

          {/* <div className={classes.Group}>
            <label>Currencyddd</label>
            <select
              value={selectedCurrency}
              onChange={(e) => setSelectedCurrency(e.target.value)}
            >
              <option value="">Select Currency</option>
              {currencyOptions.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.code || c.name}
                </option>
              ))}
            </select>
          </div> */}
        </div>

        <div className={classes.topRows}>
          <div className={classes.Group1}>
            <label>Description</label>
            <input
              type="text"
              placeholder="Enter description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          <div className={classes.Group2}>
            <label>Mode of Payment</label>
            <div className={classes.searchableDropdown}>
              <input
                type="text"
                placeholder="Search or select payment mode..."
                value={paymentSearch}
                onChange={(e) => setPaymentSearch(e.target.value)}
                onFocus={() => setShowPaymentDropdown(true)}
                onClick={() => setShowPaymentDropdown(!showPaymentDropdown)}
                className={classes.accountInput}
              />

              {showPaymentDropdown && (
                <div
                  className={classes.dropdownList}
                  onMouseLeave={() => setShowPaymentDropdown(false)}
                >
                  {paymentModes.length === 0 ? (
                    <div>No payment modes found</div>
                  ) : (
                    paymentModes
                      .filter((m) =>
                        (m.name || m.method_name || "").toLowerCase().includes(paymentSearch.toLowerCase())
                      )
                      .map((m) => (
                        <div
                          key={m.id}
                          className={classes.dropdownItem}
                          onClick={() => {
                            setSelectedPaymentMode(m.id);
                            setPaymentSearch(m.name || m.method_name || "");
                            setShowPaymentDropdown(false);
                          }}
                        >
                          {m.name || m.method_name}
                        </div>
                      ))
                  )}
                </div>
              )}
            </div>
          </div>

          <div className={classes.Group2}>
            <label>Bank Account</label>
            <div className={classes.searchableDropdown}>
              <input
                type="text"
                placeholder="Search or select debit account..."
                value={debitSearch}
                onChange={(e) => setDebitSearch(e.target.value)}
                onFocus={() => setShowDebitDropdown(true)}
                onClick={() => setShowDebitDropdown(!showDebitDropdown)}
                className={classes.accountInput}
                disabled={debitAccountsLoading}
              />

              {showDebitDropdown && (
                <div
                  className={classes.dropdownList}
                  onMouseLeave={() => setShowDebitDropdown(false)}
                >
                  {debitAccountsLoading ? (
                    <div>Loading accounts...</div>
                  ) : creditAccounts.length === 0 ? (
                    <div>No accounts found</div>
                  ) : (
                    creditAccounts
                      .filter((acc) =>
                        (acc.label || "").toLowerCase().includes(debitSearch.toLowerCase())
                      )
                      .map((acc) => (
                        <div
                          key={acc.value}
                          className={classes.dropdownItem}
                          onClick={() => {
                            setDebitAccount(JSON.stringify({ id: acc.value, gl_code: acc.gl_code }));
                            setDebitSearch(acc.label || "");
                            setShowDebitDropdown(false);
                          }}
                        >
                          {acc.label}
                        </div>
                      ))
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={classes.top}>
          <div className={classes.Group1}>
            <label>Amount</label>
            <input
              type="number"
              placeholder="Enter Amount"
              style={{ textAlign: "right" }}
              value={totalAmount}
              onChange={(e) => setTotalAmount(e.target.value)}
            />
          </div>

          {/* <div className={classes.Group2}>
            <label>Loan Account</label>
            <select
              value={selectedLoanAccount}
              onChange={(e) => setSelectedLoanAccount(e.target.value)}
              disabled
            >
              <option value="">Select Loan Account (Coming Soon)</option>
              <option value="loan-1">Loan #001 - Placeholder</option>
              <option value="loan-2">Loan #002 - Placeholder</option>
            </select>
          </div> */}

          <div className={classes.Group2}>
            <label>Cheque Number</label>
            <input
              type="text"
              placeholder="Enter cheque number"
              value={chequeNo}
              onChange={(e) => setChequeNo(e.target.value)}
            />
          </div>

          {(() => {
            const selectedModeName = paymentModes.find(
              (m) => m.id == selectedPaymentMode
            )?.name?.toLowerCase();

            if (selectedModeName?.includes("loan")) {
              return (
                <div className={classes.Group2}>
                  <label>Outstanding</label>
                  <input
                    type="number"
                    placeholder="0.00"
                    value={outstandingAmount || ""}
                    disabled
                  />
                </div>
              );
            }
            return null;
          })()}
        </div>

        <div className={classes.Group2}>
          <label>Supporting Document</label>
          <input
            type="file"
            accept="application/pdf"
            onChange={handleFileChange}
            className={classes.fileInput}
          />
          {supportingError && (<div style={{ color: 'red', marginTop: 6 }}>{supportingError}</div>)}
          {/* {supportingDocument && (
            <div style={{ marginTop: 6 }}>
              {supportingDocument.name} <button type="button" onClick={() => { setSupportingDocument(null); setSupportingError(""); }}>Remove</button>
            </div>
          )} */}
        </div>

        {/* <table className={classes.table}>
          <thead>
            <tr>
              <th>#</th>
              <th>Account Name</th>
              <th>Account Code</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
             {selectedProducts.map((product, index) => (
            <tr key={product.id}>
              <td className={classes.accountCell}>{index + 1}</td>
              <td>{product.savings_liability_gl?.gl_name || "-"}</td>
               <td>{product.savings_liability_gl?.gl_code || "-"}</td>
              <td>{totalAmount}</td>
            </tr>
          ))}
          </tbody>
        </table> */}

        {/* <div className={classes.totalRow}>
          <div className={classes.totalBox}>
            <span>Total Debit</span>
            <strong>{totalDebit.toFixed(2)}</strong>
          </div>
          <div className={classes.totalBox}>
            <span>Total Credit</span>
            <strong>{totalCredit.toFixed(2)}</strong>
          </div>
        </div> */}

        <form 
        // onSubmit={handleSubmit}
        >
          <div className={classes.footerButtons}>
            <button
              type="button"
              className={classes.resetBtn}
              onClick={resetFormFields}
            >
              Reset
            </button>

            <button type="button" className={classes.printBtn} onClick={handlePrinter}>
              Print
            </button>

            <button
              type="submit"
              onClick={handleSubmit}
              className={classes.submitBtn}
              // disabled={isSaving || !isBalanced || !selectedPaymentType || !reference || !transactionDate || !selectedPaymentMode || !debitAccount}
            >
              {isSaving ? (
                <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                  <Spinner animation="border" size="sm" /> Saving...
                </span>
              ) : (
                "Save Payment"
              )}
            </button>
          </div>
        </form>

        <button className={classes.closeBtn} onClick={onClose}>
          ×
        </button>
      </div>
    </div>
  );
}

export default MemberCollectionsModal;